import { useEffect, useState } from "react";

import { getFiledConfig } from "../../services/backend/FiledConfigService";

// config/filed for a page: undefined while loading, null if it could not be
// read. Not loaded without a signed-in user (the public QR page needs none).
export default function useFiledConfig(user) {
  const signedIn = !!user;
  const [config, setConfig] = useState(undefined);

  useEffect(() => {
    if (!signedIn) return undefined;
    let alive = true;
    getFiledConfig().then((value) => {
      if (alive) setConfig(value);
    });
    return () => {
      alive = false;
    };
  }, [signedIn]);

  return config;
}
